import React, { useState } from 'react';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import { TextInput } from '../../../../../components/textInput/TextInput';
import { Grid } from '@mui/material';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';

export const SearchInput = ({
    rows,
    columns,
    value,
    paginationStatus,
    handleChangePaginationStatus,
    totalCount,
    filterStatus,
    setFilterStatus,
    handleRowClick,
    entityName = '',
    description = ''
}) => {

    const [openModalBuscarCentro, setOpenModalBuscarCentro] = useState(false);

    const handleSearchCentro = () => setOpenModalBuscarCentro(true);

    const handleCloseSearchCentro = () => {
        setOpenModalBuscarCentro(false);
    }

    return (
        <>
            <TextInput
                label={`Buscar ${entityName}`}
                onClick={handleSearchCentro}
                placeholder='Buscar'
                value={value}
                searchIcon
                sx={{ mt: 2.5 }}
            />
            <CustomDialog
                open={openModalBuscarCentro}
                maxWidth='md'
                fullWidth={true}
                title={`Agregar ${entityName}`}
                onCancel={handleCloseSearchCentro}
            >
                <Grid
                    container
                    justifyContent={'space-between'}
                >
                    {description && <Grid size={{ xs: 12 }}>
                        <div className='grid-resumen-ingreso-title'>
                            <div>{description}</div>
                        </div>
                    </Grid>}
                    <Grid sx={{ my: 2.5 }} size={{ xs: 12 }}>
                        <TextInput
                            placeholder='Filtrar'
                            value={filterStatus}
                            searchIcon
                            onChange={(e) => setFilterStatus(e.target.value)}
                            onClearButtonClick={() => setFilterStatus('')}
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <DataGridGenerico
                            hideFooterPagination={false}
                            toolbar={false}
                            columns={columns}
                            rows={rows}
                            onPageChange={(page) =>
                                handleChangePaginationStatus(prev => ({
                                    ...prev,
                                    page: page
                                }))
                            }
                            onPageSizeChange={(pageSize) =>
                                handleChangePaginationStatus(prev => ({
                                    ...prev,
                                    pageSize: pageSize,
                                    page: 0
                                }))
                            }
                            pageSize={paginationStatus.pageSize}
                            totalCount={totalCount}
                            currentPage={paginationStatus.page}
                            onRowClick={(row) => {
                                handleRowClick(row);
                                handleCloseSearchCentro()
                            }}
                        />
                    </Grid>
                </Grid>
            </CustomDialog>
        </>
    )
}